<template>
  <v-snackbar
      app
      :timeout="-1"
      :value="connectingState"
      color="red darken-1"
      absolute
      right
      bottom
      shaped
      class="conn-info d-flex"
      height="80"
      width="500"
  >
    <v-row>
      <v-col cols="3">
        <v-img
            :src="require('../../assets/images/gears.svg')"
            height="60"
            width="80"
        />
      </v-col>
      <v-col
          cols="9"
          class="d-flex align-center text-h5"
      >
        Касса не работает. Подключаемся...
      </v-col>
    </v-row>
  </v-snackbar>
</template>

<script>

  import {mapGetters} from "vuex";

  export default {
    name: 'connectingInfo',
    computed: {
      ...mapGetters({
        connectingState:'login/centrifugeConnecting',
      }),
    }
  }
</script>

<style>
.v-snack--bottom.conn-info {
  z-index: 2000;
  position: fixed!important;
  bottom: 50px;
  right: 50px;
}
cog {
  transform-origin: 20.3% 32.2%;
  transform: rotate(0deg);
  animation: cog 1.5s infinite;
  animation-timing-function: linear;
}
@keyframes cog {
  0% {transform: rotate(0deg);}
  100% {transform: rotate(-360deg);}
}
sprocket {
  transform-origin: 64.1% 49.9%;
  transform: rotate(0deg);
  animation: sprocket 3s infinite;
  animation-timing-function: linear;
}
@keyframes sprocket {
  0% {transform: rotate(0deg);}
  100% {transform: rotate(360deg);}
}
</style>